<section global-hero [heroData]="heroData"></section>
<section
  jump-to
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
></section>
<!-- <section id="what-is-type-1-diabetes" t1d></section> -->
<!-- <section section-1></section> -->
<section beta-cells></section>
<section stages id="what-are-the-stages-of-type-1"></section>
<section callout [data]="calloutItems[2]" class="pt-0"></section>
<section
  id="The-risks-are-real"
  image-with-title
  [data]="imageTitleData"
  class="custom-height-cta"
></section>
<section cta-bottom [data]="ctaBottomData"></section>
<review-bar dateText="in August 2026"></review-bar>
